import { SIMILARITY_ITEMS, SimilarityTypes, SimilarityValues } from "./select-similarity.constants";

/**
 * A similarity threshold is stored as a 0-1 fraction, while `SimilarityValues` is a percentage. This is
 * that one conversion for the exact-match case, in one place: before this existed the expression
 * `SimilarityValues.EXACT_WORD / 100` was written out at six separate call sites, so a change to the
 * enum would have had to be chased across all of them.
 */
export const EXACT_SIMILARITY_THRESHOLD = SimilarityValues.EXACT_WORD / 100;

/**
 * Whether a stored similarity threshold means "exact match".
 * @param similarityThreshold The threshold as stored on a form row, i.e. a 0-1 fraction, or null when unset.
 */
export const isExactSimilarity = (similarityThreshold: number | null | undefined): boolean =>
    similarityThreshold === EXACT_SIMILARITY_THRESHOLD;

/**
 * Every similarity option that is not an exact match, derived from `SIMILARITY_ITEMS` rather than listed
 * by hand so a newly added option is covered automatically. These are the options unavailable to message
 * sources that only support exact matching.
 */
export const NON_EXACT_SIMILARITY_TYPES: SimilarityTypes[] = SIMILARITY_ITEMS.map(({ type }) => type).filter(
    (type) => type !== SimilarityTypes.EXACT_WORD
);
